// this Js file is use for the tenant settings like brand name, logo etc. 

export default class Setting {
    constructor() {
        this.brandName = window.APP?.brandName ?? 'InstaWP'
        this.brandShortName = window.APP?.brandShortName ?? 'InstaWP'
        this.logo = window.APP?.logo ?? ''
        this.icon = window.APP?.icon ?? ''
        this.grayLogo = window.APP?.grayLogo ?? ''
        this.billingLogo = window.APP?.billingLogo ?? ''
        this.googleLoginEnabled = window.APP?.googleLoginEnabled ?? false
        this.twitterLoginEnabled = window.APP?.twitterLoginEnabled ?? false
        this.facebookLoginEnabled = window.APP?.facebookLoginEnabled ?? false
        this.primaryColor = window.APP?.primaryColor ?? '#005E54'
        this.secondaryColor = window.APP?.secondaryColor ?? '#15B881'
        this.tertiaryColor = window.APP?.tertiaryColor ?? '#F2FFFA'
        this.supportEmail = window.APP?.supportEmail?.trim() || 'support@instawp.com'
        this.termsAndConditions = window.APP?.termsAndConditions ?? ''
        this.privacyPageUrl = window.APP?.privacyPageUrl ?? ''
    }
}